// import messaging from 'config/firebase'

export function initializePush(firebaseContext, isFaculty, profile) {
	const { fcmTokens } = profile;
	let newTokens = [];

	if (firebaseContext.messaging) {
		firebaseContext.messaging
			.requestPermission()
			.then(() => {
				return firebaseContext.messaging.getToken();
			})
			.then(token => {
				if(fcmTokens) {
					if(!fcmTokens.includes(token))
						fcmTokens.push(token);
					newTokens = fcmTokens;
				} else {
					newTokens = [token];
				}
				if(isFaculty) {
					firebaseContext.faculty(profile.id).set({fcmTokens : newTokens}, { merge: true});
				} else {
					firebaseContext.student(profile.id).set({fcmTokens : newTokens}, { merge: true});
				}
				console.log("FCM Token:", token);

			})
			.catch(error => {
				if (error.code === "messaging/permission-blocked") {
					console.log("Please Unblock Notification Request Manually");
				} else {
					console.log("Error Occurred", error);
				}
			});

		firebaseContext.messaging.onMessage(payload => {
			// toastr.info(payload.body, payload.title)
			console.log('upcoming notification', payload);
		});

	}
}

export const addIOSFCMToken  = (firebaseContext, isFaculty, profile, token) => {
	const { fcmTokens } = profile;
	let newTokens = [];
	if(fcmTokens) {
		if(!fcmTokens.includes(token))
			fcmTokens.push(token);
		newTokens = fcmTokens;
	} else {
		newTokens = [token];
	}
	if(isFaculty) {
		firebaseContext.faculty(profile.id).set({fcmTokens : newTokens}, { merge: true});
	} else {
		firebaseContext.student(profile.id).set({fcmTokens : newTokens}, { merge: true});
	}
}